import { render, staticRenderFns } from "./LuckycRoom.vue?vue&type=template&id=306fa666&scoped=true&"
import script from "./LuckycRoom.vue?vue&type=script&lang=js&"
export * from "./LuckycRoom.vue?vue&type=script&lang=js&"
import style0 from "./LuckycRoom.vue?vue&type=style&index=0&id=306fa666&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306fa666",
  null
  
)

export default component.exports